module.exports = __webpack_public_path__ + "static/media/star_nord-z_90.c25b51f8.png";